var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"checkin-bottom-navigation",attrs:{"app":"","bottom":"","elevation":"1"}},[_vm._t("prev-button"),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_vm._t("next-button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }